import { Link } from 'react-router-dom'

const BookCard = ({ book }) => {
  return (
    <div
      className='box-card book-card'
      key={book.id}
    >
      <img
        alt={book.title}
        src={book.cover}
      />
      <Link
        className='edit-book-button'
        to={`/books/edit/${book.id}`}
        title='Editar livro'
      >
        <i className='fa fa-pen'></i>
      </Link>
      <h5 className='book-title'>{book.title}</h5>
    </div>
  )
}

export default BookCard
